import '@fontsource-variable/inter/wght.css';
import './theme/global.css';

import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ProjectAlertProvider } from './alerts/ProjectAlertContext';
import { setUpAntdForReact19 } from './antdReact19';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { brandTheme } from './theme/brand';

/*
  PHẢI gọi TRƯỚC khi dựng giao diện. Nếu gọi sau, một hộp thoại hay thông báo phát sinh trong nhịp
  vẽ đầu tiên sẽ dùng cách dựng cũ và im lặng không hiện gì — đúng lỗi mà tệp antdReact19 mô tả.
*/
setUpAntdForReact19();

const container = document.getElementById('root');

if (container === null) {
  throw new Error('Không tìm thấy phần tử gốc để dựng giao diện.');
}

createRoot(container).render(
  <StrictMode>
    {/*
      Đặt ngôn ngữ tiếng Việt cho toàn bộ thư viện thành phần: nút bấm, bộ chọn ngày, phân trang
      và thông báo xác thực đều theo tiếng Việt. Thiếu bước này thì giao diện lẫn hai ngôn ngữ,
      và bộ chọn ngày hiển thị thứ trong tuần bằng tiếng Anh.

      Chủ đề mang bảng màu và font của thương hiệu MVA Lab cho mọi thành phần — xem theme/brand.ts.
    */}
    <ConfigProvider locale={viVN} theme={brandTheme}>
      {/*
        Bộ định tuyến bọc ngoài phần xác thực, vì phần xác thực cần điều hướng được khi phiên
        hết hiệu lực. Bọc theo thứ tự ngược lại thì lời gọi điều hướng không tìm thấy bộ định tuyến.
      */}
      <BrowserRouter>
        <AuthProvider>
          {/*
            Cảnh báo nằm TRONG phần xác thực vì nó cần biết người đang đăng nhập là ai và có quyền
            gì. Bọc theo thứ tự ngược lại thì nó không đọc được trạng thái xác thực.

            Bọc ở đây chứ không bọc trong App: cả khung bố cục (chuông trên thanh tiêu đề) lẫn trang
            chủ (danh sách đầy đủ) đều đọc cùng một con số, và cả hai nằm dưới điểm này.
          */}
          <ProjectAlertProvider>
            <App />
          </ProjectAlertProvider>
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  </StrictMode>,
);
